import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './AddTypePage.css';
import TypeForm from '../../../components/type/TypeForm/TypeForm';
import { postType } from '../../../store/types/actions';
import { TYPE_PAGE } from '../../../constants/routes';
import withTranslation from '../../../hoc/withTranslation';

export class AddTypePage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        lang: PropTypes.string,
        postType: PropTypes.func,
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.type && !nextProps.typeError) {
            let url = TYPE_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':typeId', nextProps.type.id);
            this.props.history.push(url);
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        if (isNaN(formProps.display_order)
            || formProps.display_order === ''
            || formProps.display_order === null
        ) {
            formProps = {
                ...formProps,
                display_order: 0,
            };
        }
        await this.props.postType(this.props.app.id, formProps, this.props.lang);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Type / Add - {this.props.app.name}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('settings_page.new_type')}
                                </Subheader>
                                <div style={style.paper}>
                                    <TypeForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.types.pending,
        error: state.apps.error,
        typeError: state.types.error,
        type: state.types.currentType,
        app: state.apps.currentApplication,
        sending: state.types.sending,
        lang: state.ui.currentLang,
    };
}

export default connect(mapStateToProps, {
    postType,
    fetchApp,
})(withTranslation(AddTypePage));



// WEBPACK FOOTER //
// src/containers/types/AddTypePage/AddTypePage.js